<template>
  <!-- View Legal basis modal template -->
  <b-modal ref="view-io" hide-footer @hide="hidePolicyModal" v-if="object">
    <div class="d-block text-center">
      <h4 qid="update-tp-title">
        {{ $t('systems.network.view.title') }}
      </h4>
    </div>

    <label class="mt-3">
      {{ $t('systems.network.table.name') }}
    </label>
    <br>
    <span v-if="object.network" qid="network-name">
      {{ object.network.name }}
    </span>
    <br>

    <div v-if="object.description">
      <label class="mt-4">
        {{ $t('systems.network.table.description') }}
      </label>
      <br>
      <div class="text-formatted mt-minus-1 mb-minus-1"
            qid="network-description"
      >
        {{ object.description }}
      </div>
      <br>
    </div>

    <div v-if="object.exposed_to_open_networks">
      <label class="mt-4">
        {{ $t('systems.network.table.exposed_to_open_networks') }}
      </label>
      <br>
      <span qid="network-exposed">
        {{ object.exposed_to_open_networks }}
      </span>
      <br>
    </div>

    <b-button class="mt-4 float-right"
              variant="success"
              @click="hidePolicyModal"
              qid="create-p-cancel-button"
    >
      {{ $t('processes.policies.view.close') }}
    </b-button>
    <br>

  </b-modal>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'NetworkViewModal',
    data: function() {
      return {
        error: '',
        processGroup: [],
        showInput: false,
        loadingItems: false,
        showArticleDescription: false
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getMedia() {
        return this.object.media
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showPolicyModal()
        }
      }
    },
    methods: {
      showPolicyModal() {
        let self = this
        this.$refs['view-io'].show()
      },
      hidePolicyModal() {
        this.error = ''
        this.showArticleDescription = false;
        this.$emit('closeViewModal');
        this.$refs['view-io'].hide()
      }
    },
    components: {

    },
    created () {

    }
  }
</script>
